import { SupplierOrderInput } from 'models/order-input/supplier-order';
import React, { createContext, useContext, useRef, useState } from 'react';

type SupplierOrderContextType = {
    order: SupplierOrderInput;
    updateOrder: (updates: Partial<SupplierOrderInput>) => void;
    resetOrder: () => void;
};
export const SupplierOrderContext = createContext<SupplierOrderContextType>({
    order: {} as SupplierOrderInput,
    updateOrder: () => {
        return;
    },
    resetOrder: () => {
        return;
    },
});

export const SupplierOrderProvider = ({
    initialOrder,
    children,
}: {
    initialOrder: SupplierOrderInput;
    children: React.ReactNode;
}) => {
    const [order, setOrder] = useState(initialOrder);
    const originalOrder = useRef(initialOrder);

    const updateOrder = (updates: Partial<SupplierOrderInput>) => {
        setOrder((prev) => ({ ...prev, ...updates }));
    };

    const resetOrder = () => {
        setOrder(originalOrder.current);
    };

    return (
        <SupplierOrderContext.Provider value={{ order, updateOrder, resetOrder }}>
            {children}
        </SupplierOrderContext.Provider>
    );
};

export const useSupplierOrder = () => {
    const ctx = useContext(SupplierOrderContext);
    if (!ctx) throw new Error('useSupplierOrder must be used within SupplierOrderProvider');
    return ctx;
};
